import { Container, Grid } from "@mui/material";
import logo from "../../images/logo.png";
import styles from "../../styles/EventManager.module.scss";
import React from "react";
import DataTable from "../../components/dataTable";

type TProps = {
  logoFromDB?: string,
  fontColor?: string
}

const PageEventManager = ({logoFromDB, fontColor}: TProps) => {
  return (
    <article>
        <Grid container spacing={2}>
          <img className={styles.logo} src={logoFromDB ? logoFromDB : logo} alt="logo" />
        </Grid>

          <Grid item xs={12} md={12}>
            <DataTable fontColor={fontColor ? fontColor : '#ffffff'} />
          </Grid>
    </article>
  );
};

export default React.memo(PageEventManager);
